import React, { useContext, useEffect, useState } from 'react';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import TreeCategory from './TreeCategory';
import { PlaceStoreContext } from '../../../../../reducers/Place/PlaceContext';
import { AuthContext } from '../../../../../reducers/Auth/AuthContext';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import HeaderTag from '../../../../../lib/reusable/HeaderTag';
import TreeGroup from './TreeGroup';
import QueueIcon from '@mui/icons-material/Queue';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import ReactModal from '../../../../../components/ReactModal';
import ManageCategory from '../../../../../components/ManageCategory';
import Repositions from './Repositions';
import { COLORS } from '../../../../../utils/colors';
import config from '../../../../../utils/config';

const TreeMenu = (props) => {
  const { serviceId } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [authState] = useContext(AuthContext);
  const startExpanded = {};
  startExpanded[serviceId] = true;
  const [expanded, setExpanded] = useState({ startExpanded });
  const {
    user: { placeId },
  } = authState;
  const [tree, setTree] = useState([]);
  const [newCatgoryModalIsOpen, setNewCatgoryModalIsOpen] = useState(false);
  const [mainCategoriesRepositionModalIsOpen, setMainCategoriesRepositionModalIsOpen] =
    useState(false);

  const {
    products: { productId__product, index: indexProducts },
    categories: {
      categoryId__category,
      index: indexCategories,
      gorupCategoryId__categories,
      categoryId_extraProducts,
    },
    services: { serviceId__service },
  } = placeState;

  const service = serviceId__service[serviceId];

  const getTreeCategory = (category, initialExpanded) => {
    const products = [];
    const productIdsWithImages = [];
    if (
      indexCategories.categoryId__productsId[category.id] ||
      categoryId_extraProducts[category.id]
    ) {
      initialExpanded[category.id] = false;
      for (const productId of indexCategories.categoryId__productsId[category.id] || []) {
        const product = productId__product[productId];
        if (product.has_image) {
          product.image = `${config.uri.bucket}/${placeId}/low/${
            product.id
          }.jpg?time=${new Date().getTime()}`;
          productIdsWithImages.push(product.id);
        }
        products[product.position - 1] = product;
      }

      if (categoryId_extraProducts[category.id]) {
        category.products = [...products, ...categoryId_extraProducts[category.id]].filter((product) => product?.id !== undefined);
      } else {
        category.products = products.filter((product) => product?.id !== undefined);
      }
    }
    if (category.has_image) {
      category.image = `${config.uri.bucket}/${placeId}/low/${
        category.id
      }.jpg?time=${new Date().getTime()}`;
    } else if (productIdsWithImages.length > 0) {
      const productIdWithImage =
        productIdsWithImages[Math.floor(Math.random() * productIdsWithImages.length)];
      category.image = `${
        config.uri.bucket
      }/${placeId}/low/${productIdWithImage}.jpg?time=${new Date().getTime()}`;
    }

    return category;
  };

  useEffect(() => {
    const newTree = [];
    const initialExpanded = {};
    initialExpanded[serviceId] = true;
    for (const categoryId in categoryId__category) {
      const category = categoryId__category[categoryId];
      if (category.service_id !== serviceId) continue;
      if (category.id === 'new') continue;

      const isSubCategory = category.nested && category.group === false;

      if (isSubCategory) continue;

      const isGroup = category.nested === null && category.group === true;

      if (isGroup) {
        const subCategories = gorupCategoryId__categories[categoryId];
        const orderedSubCategoriesWithProducts = [];
        for (const subCategory of subCategories || []) {
          const treeCategory = getTreeCategory(subCategory, initialExpanded);
          orderedSubCategoriesWithProducts.push(treeCategory);
        }
        category.categories = orderedSubCategoriesWithProducts.sort(
          (a, b) => b.position - a.position,
        );
        newTree[category.position - 1] = category;
        continue;
      }

      const treeCategory = getTreeCategory(category, initialExpanded);
      newTree[treeCategory.position - 1] = treeCategory;
    }
    setTree(newTree);
    setExpanded({ ...initialExpanded, ...expanded });
  }, [placeState, serviceId]);

  const handleRepositionMainCategories = (e) => {
    e.stopPropagation();
    const newExpanded = { ...expanded };
    newExpanded[serviceId] = true;
    setExpanded(newExpanded);
    setMainCategoriesRepositionModalIsOpen(true);
  };

  const handleAddCategory = (e) => {
    e.stopPropagation();
    const newExpanded = { ...expanded };
    newExpanded[serviceId] = true;
    setExpanded(newExpanded);
    setNewCatgoryModalIsOpen(true);
  };

  const handleMainLabel = () => {
    const newExpanded = { ...expanded };
    newExpanded[serviceId] = expanded[serviceId] ? !expanded[serviceId] : true;
    setExpanded(newExpanded);
  };

  if (!service) return null;

  const MainLable = (
    <div className="f-c f-aic" style={{ minHeight: '56px' }}>
      <HeaderTag
        name={`${service.name.toUpperCase()} CATEGORIES`}
        color={COLORS.S_DARK_TEXT}
        size="1rem"
        style={{ marginBottom: 0 }}
      />
      <FormatListNumberedIcon
        className="s-24-i txt-info pl-16 pr-4"
        onClick={handleRepositionMainCategories}
      />
      <QueueIcon className="s-24-i txt-info pl-4 pr-8" onClick={handleAddCategory} />
    </div>
  );

  const expandedArray = Object.keys(expanded).filter((key) => expanded[key] === true);

  return (
    <>
      <TreeView
        disableSelection
        defaultExpanded={[serviceId]}
        defaultCollapseIcon={<ArrowDropDownIcon style={{ fontSize: 24 }} />}
        defaultExpandIcon={<ArrowRightIcon style={{ fontSize: 24 }} />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        expanded={expandedArray}
      >
        <TreeItem nodeId={serviceId} label={MainLable} onClick={handleMainLabel}>
          {tree.map((category) => {
            const isCategory = category.nested === null && category.group === false;

            if (isCategory) {
              return (
                <TreeCategory
                  key={category.id}
                  category={category}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />
              );
            }

            return (
              <TreeGroup
                key={category.id}
                category={category}
                expanded={expanded}
                setExpanded={setExpanded}
              />
            );
          })}
        </TreeItem>
      </TreeView>
      {newCatgoryModalIsOpen && (
        <ReactModal modalIsOpen={newCatgoryModalIsOpen} setIsOpen={setNewCatgoryModalIsOpen}>
          <ManageCategory
            categoryId="new"
            serviceId={serviceId}
            close={() => setNewCatgoryModalIsOpen(false)}
          />
          <div style={{ height: '200px' }} />
        </ReactModal>
      )}
      {mainCategoriesRepositionModalIsOpen && (
        <ReactModal
          modalIsOpen={mainCategoriesRepositionModalIsOpen}
          setIsOpen={setMainCategoriesRepositionModalIsOpen}
        >
          <Repositions
            reposition={{
              type: 'categories',
              filter: serviceId,
            }}
            close={() => setMainCategoriesRepositionModalIsOpen(false)}
          />
        </ReactModal>
      )}
    </>
  );
};

export default TreeMenu;
